'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index$1 = require('../../node_modules/classnames/index.js');

var index = require('../../node_modules/prop-types/index.js');

var Carousel = require('../Carousel/Carousel.js');

var CarouselInner = require('../Carousel/CarouselInner/CarouselInner.js');

var useScreenSize = require('../../utilities/hooks/useScreenSize.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var CardCarousel = function CardCarousel(props) {
  var children = props.children,
      className = props.className,
      length = props.length,
      cardSizeLg = props.cardSizeLg,
      cardSizeSm = props.cardSizeSm,
      controlsColor = props.controlsColor;
  var classes = index$1['default']('lanl-card-carousel', className);
  var screenWidth = useScreenSize.useScreenSize();
  var cardSize = screenWidth < 768 ? cardSizeSm : cardSizeLg;

  var disableRight = function disableRight() {
    var calcScreen = screenWidth < 1600 ? screenWidth : screenWidth - (screenWidth - 1600) / 2;
    return Math.floor(calcScreen / cardSize);
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes,
    "data-testid": "lanl-card-carousel"
  }, /*#__PURE__*/React__default['default'].createElement(Carousel.Carousel, {
    activeItem: 0,
    card: true,
    cardSize: cardSize,
    controlsColor: controlsColor,
    controlsOutside: true,
    length: length,
    loop: false,
    showControls: true,
    showIndicators: false,
    slide: true,
    stopRight: disableRight()
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "lanl-card-carousel-container"
  }, /*#__PURE__*/React__default['default'].createElement(CarouselInner.CarouselInner, null, children))));
};

CardCarousel.defaultProps = {
  cardSizeLg: 390,
  cardSizeSm: 325,
  controlsColor: 'standard'
};
CardCarousel.propTypes = {
  children: index['default'].node.isRequired,
  length: index['default'].number.isRequired,
  cardSizeLg: index['default'].number,
  cardSizeSm: index['default'].number,
  className: index['default'].string,
  controlsColor: index['default'].oneOf(['white', 'standard'])
};
exports.CardCarousel = CardCarousel;
exports['default'] = CardCarousel;